var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2944 66.3752C68.739 63.9181 72.7127 63.908 75.1698 66.3526L98.0944 89.1609C100.552 91.6056 100.562 95.5792 98.117 98.0363C95.6724 100.493 91.6987 100.504 89.2416 98.0589L66.3169 75.2506C63.8598 72.806 63.8497 68.8323 66.2944 66.3752Z",
    fill: "url(#paint0_linear_1957_7748)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2648 50.7901C58.9283 49.8513 56.9845 46.3855 57.9233 43.049L66.6818 11.9195C67.6206 8.58298 71.0864 6.63921 74.4229 7.57797C77.7595 8.51673 79.7032 11.9825 78.7645 15.3191L70.0059 46.4486C69.0672 49.7851 65.6013 51.7289 62.2648 50.7901Z",
    fill: "url(#paint1_linear_1957_7748)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7842 62.768C50.6635 66.1207 48.6583 69.5514 45.3056 70.4306L14.0251 78.6337C10.6724 79.5129 7.24175 77.5077 6.36253 74.155C5.4833 70.8023 7.48846 67.3717 10.8412 66.4924L42.1216 58.2894C45.4744 57.4102 48.905 59.4153 49.7842 62.768Z",
    fill: "url(#paint2_linear_1957_7748)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0228 61.8899L21.3899 30.1532L30.2798 21.2923L61.9122 53.0284L105.118 41.4039L108.379 53.5246L65.1418 65.1576L53.641 108.363L41.5116 105.135L53.0228 61.8899Z",
    fill: "#EC6643"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.492 13.3793L25.8713 25.8713L13.3793 72.492L47.508 106.621L94.1287 94.1288L106.621 47.508L72.492 13.3793ZM78.4393 1.57569C77.0803 0.216738 75.0996 -0.313992 73.2433 0.183419L18.6227 14.819C16.7663 15.3164 15.3164 16.7663 14.819 18.6227L0.183419 73.2433C-0.313992 75.0996 0.216738 77.0804 1.57569 78.4393L41.5607 118.424C42.9197 119.783 44.9004 120.314 46.7567 119.817L101.377 105.181C103.234 104.684 104.684 103.234 105.181 101.377L119.817 46.7567C120.314 44.9004 119.783 42.9197 118.424 41.5607L78.4393 1.57569Z",
    fill: "#EC6643"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1957_7748",
    x1: 85.1084,
    y1: 85.0471,
    x2: 70.2504,
    y2: 71.3358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#EC6643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6643",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1957_7748",
    x1: 69.4121,
    y1: 25.2651,
    x2: 64.6713,
    y2: 44.9192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#EC6643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6643",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1957_7748",
    x1: 24.1529,
    y1: 69.5239,
    x2: 43.5029,
    y2: 63.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#EC6643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6643",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon);
export default __webpack_public_path__ + "static/media/Logo icon.f73b8e5aba9d8985d3ad6008643655db.svg";
export { ForwardRef as ReactComponent };